<div class="expansion-data">
  <div class="expansion-data-title" *ngIf="title">{{title}}</div>
  <div class="expansion-data-row" *ngFor="let data of dataList">
    <div  *ngFor="let row of data.rows">
      <div class="expansion-data-item" *ngIf="!row.type || row.type === detailFieldTypes.text || row.type === detailFieldTypes.number">
        <span class="lab">{{row.label}}</span>
        <div class="texto" innerHTML="{{row.value || 'n/a'}}"></div>
      </div>
      <div class="expansion-data-attachment" *ngIf="row.type === detailFieldTypes.attachment">
        <fa-icon icon="file-upload"></fa-icon>
        <div class="texto" innerHTML="{{row.value || 'n/a'}}"></div>
      </div>
      <div class="expansion-data-item only-val" *ngIf="row.type === detailFieldTypes.onlyVal">
        <div class="texto" innerHTML="{{row.value || 'n/a'}}"></div>
      </div>
    </div>
  </div>
</div>
